'use client';
import { DependencyList, useEffect, useRef } from 'react';

export function useConstant<T>(factory: () => T, deps: DependencyList = []): T {
  const mountRef = useRef(false);
  const valueRef = useRef<T>(undefined);
  if (!valueRef.current) {
    valueRef.current = factory();
  }
  useEffect(() => {
    if (!mountRef.current) {
      mountRef.current = true;
    } else {
      valueRef.current = factory();
    }
  }, deps);

  return valueRef.current;
}
